import { render } from "./HelperDownload.vue?vue&type=template&id=a3edf9ce&scoped=true"
import script from "./HelperDownload.vue?vue&type=script&lang=js"
export * from "./HelperDownload.vue?vue&type=script&lang=js"

import "./HelperDownload.vue?vue&type=style&index=0&id=a3edf9ce&scoped=true&lang=scss"
import "./HelperDownload.vue?vue&type=style&index=1&id=a3edf9ce&lang=scss"

import exportComponent from "/pxplus_official_website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3edf9ce"]])

export default __exports__